import { Combobox, Input, InputBase, Text, useCombobox } from '@mantine/core';
import React, { useState } from 'react';

interface SelectionBoxProps {
    values: string[];
    defaultValue?: string;
    placeholder?: string;
    label?: string;
    required?: boolean;
    withAsterisk?: boolean;
}

function SelectionBox({ values, defaultValue, placeholder, label, required, withAsterisk }: SelectionBoxProps) {
    const combobox = useCombobox({
        onDropdownClose: () => combobox.resetSelectedOption(),
    });

    const [value, setValue] = useState<string | null>(defaultValue ? defaultValue : null);

    const options = values.map((item) => (
        <Combobox.Option value={item} key={item}>
            {item}
        </Combobox.Option>
    ));


    return (
        <Combobox
            store={combobox}
            onOptionSubmit={(val) => {
                setValue(val);
                combobox.closeDropdown();
            }}
        >
            <Combobox.Target>
                <InputBase
                    pointer
                    label={label}
                    withAsterisk={withAsterisk}
                    required={required}
                    component="button"
                    rightSection={<Combobox.Chevron />}
                    rightSectionPointerEvents="none"
                    onClick={() => combobox.toggleDropdown()}
                >
                    {value || <Input.Placeholder>{placeholder ? placeholder : "Pick a value"}</Input.Placeholder>}
                </InputBase>
            </Combobox.Target>

            <Combobox.Dropdown>
                <Combobox.Options>{options}</Combobox.Options>
            </Combobox.Dropdown>
        </Combobox>
    )
};

export default SelectionBox;